import requestAction from '../../utils/requestAction'

export const fetchRemittances = (params: string) => 
  requestAction('REMITTANCE_LIST', params)(`remittances`, 'GET')
